import React from 'react';
import moment from 'moment';
import { date, object, string } from 'yup';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from './FormResource.jsx';

const defaults = {
  orgId: '',
  rate: 0,
  startAt: '',
};
const schema = object({
  orgId: string().required('Organization ID is required'),
  rate: 0,
  startAt: date().required(),
});

const FormTaxation = ({ taxation }) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: taxation
        ? {
          ...taxation,
          startAt: taxation.startAt
            ? moment(taxation.startAt).format('YYYY-MM-DD')
            : '',
        }
        : undefined,
      onSubmit: (vs) => ({
        ...vs,
        startAt: moment(vs.startAt, 'YYYY-MM-DD').toDate(),
      }),
      api: '/api/core/taxations',
    }}>
    <div className="row">
      <div className="col">
        <FormGroup name="orgId" label="Organization ID" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="rate" label="Tax Rate" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="startAt" type="date" />
      </div>
    </div>
  </FormResource>
);

export default FormTaxation;
